import { FC } from 'react'
import { Autocomplete, Box, TextField } from '@mui/material'

interface IProps {
  label: string
  width?: number
  height?: number
  value?: { value: string | number; label: string }
  options: { value: string | number; label: string }[]
  isDisabled?: boolean
  handleChange: (value?: string | number) => void
}

export const SelectWithSearch: FC<IProps> = ({
  label,
  width,
  value,
  height,
  options,
  isDisabled,
  handleChange,
}) => {
  return (
    <Autocomplete
      id="autocomplete"
      sx={{
        width: width ?? '100%',
        '.MuiAutocomplete-inputRoot': {
          height: height ?? 'auto',
        },
      }}
      disabled={isDisabled}
      options={options}
      autoHighlight
      value={value || null}
      isOptionEqualToValue={(option, value) => option.value === value?.value}
      onChange={(_, newValue) => handleChange(newValue?.value)}
      getOptionLabel={(option) => option.label}
      renderOption={(props, option) => {
        // We don't use key for the key, because it's just the label, and we can have dupes of that.
        const { id, key, ...optionProps } = props

        return (
          <Box key={id} component="li" {...optionProps}>
            {option.label}
          </Box>
        )
      }}
      renderInput={(params) => <TextField {...params} placeholder={label} />}
    />
  )
}
